import { render } from "./IndexTeamScore.vue?vue&type=template&id=0137bc26&scoped=true"
import script from "./IndexTeamScore.vue?vue&type=script&lang=js"
export * from "./IndexTeamScore.vue?vue&type=script&lang=js"

import "./IndexTeamScore.vue?vue&type=style&index=0&id=0137bc26&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0137bc26"]])

export default __exports__